export default __webpack_public_path__ + "static/media/screen_viber_4.a607c9eb.png";